import { InjectionToken } from '@angular/core';

export const PLUGIN = new InjectionToken('pwa-plugin');
